// src/utils/attachments.js
//
// Чистые сборщики вложений и ссылок для режимов «Файлы» и «Ссылки».
// Не знают ни про React, ни про стор, ни про то, откуда пришли
// комментарии. На вход - массив и фильтр чата { projectId, taskId };
// на выход - плоский массив записей.
//
// Принадлежность чату определяется общей функцией commentInChat -
// тем же правилом, что рендер дерева и счётчики непрочитанных.

import { commentInChat } from "./commentFilter";
import { findLinks } from "./links";

/**
 * Плоский массив вложений из комментариев чата: { comment, attachment }.
 * Свежие сверху - по attachment.uploadedAt.
 */
export function collectAttachments(comments, chatFilter) {
  const { projectId, taskId } = chatFilter;
  const result = [];
  for (const comment of comments) {
    if (!commentInChat(comment, projectId, taskId)) continue;
    const attachments = comment.attachments || [];
    for (const attachment of attachments) {
      result.push({ comment, attachment });
    }
  }
  return result.sort(
    (a, b) => (b.attachment.uploadedAt || 0) - (a.attachment.uploadedAt || 0),
  );
}

/**
 * Плоский массив ссылок, email и Windows-путей из текстов комментариев:
 * { comment, url, display, kind }.
 *
 *   url     - то, что уйдёт в href (у mailto: и bare-email - mailto:,
 *             у path - исходный путь, у url - веб-ссылка);
 *   display - как напечатал автор;
 *   kind    - 'url' | 'mailto' | 'path'.
 *
 * Одно и то же упоминание, встретившееся несколько раз, попадает
 * в массив несколько раз - это разные записи с разными автором
 * и датой. Дедупликации нет.
 * Свежие сверху - по comment.createdAt.
 */
export function collectLinks(comments, chatFilter) {
  const { projectId, taskId } = chatFilter;
  const result = [];
  for (const comment of comments) {
    if (!commentInChat(comment, projectId, taskId)) continue;
    const links = findLinks(comment.text);
    for (const link of links) {
      result.push({
        comment,
        url: link.url,
        display: link.display,
        kind: link.kind,
      });
    }
  }
  return result.sort(
    (a, b) => (b.comment.createdAt || 0) - (a.comment.createdAt || 0),
  );
}
